<div class="flex h-screen  align-items-center justify-content-center"
     style="background: url('/images/signin-2.jpg.jpg') no-repeat; background-size: cover">
  <div class="flex absolute w-full h-full fixed z-5 bg-black-alpha-30" *ngIf="loading">
    <p-progressSpinner [ariaLabel]="'common.loading' | translate" [classList]="'m-auto'" />
  </div>
  <div class="bg-white p-4 shadow-5 border-round w-full lg:w-5">
    <div class="text-center mb-5">
      <img src="/images/logo.png" alt="Sakai logo" height="50"
           pStyleClass="mb-3">
      <div class="text-900 text-3xl font-medium mb-3">{{ 'login.welcomeBack' | translate }}</div>
    </div>

    <div>

      <p-toast />
      <label for="username" class="block text-900 font-medium mb-2">{{ 'login.username' | translate }}</label>
      <input pInputText id="username" type="text" [(ngModel)]="username" class="w-full mb-3" [placeholder]="'login.username' | translate"/>
      <label for="password1" class="block text-900 font-medium mb-2">{{ 'login.password' | translate }}</label>
      <p-password id="password1" [(ngModel)]="password" [toggleMask]="true" feedback="false"
                  [placeholder]="'login.password' | translate" fluid="true" styleClass="custom-password"/>




      <div class="flex align-items-center justify-content-between mb-6 mt-3">
        <div class="flex align-items-center">
          <p-checkbox id="rememberMe" [(ngModel)]="rememberMe" [binary]="true" styleClass="mr-2"></p-checkbox>
          <label for="rememberMe">{{ 'login.rememberMe' | translate }}</label>
        </div>
        <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">{{ 'login.forgotPassword' | translate }}</a>
      </div>

      <div class="col-12 text-center">
        <button pButton pRipple [label]="'login.signIn' | translate" class="col-4" style="background-color:#01d47e;border-color:#01d47e;"
                (click)="login()"></button>
      </div>
    </div>
  </div>
</div>
